module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-box--16by9 u-relative"
  }, [_c('div', {
    staticClass: "c-youtube-player u-absolute u-fit u-pos-tl js-youtube"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bf49f74"}!./src/scripts/components/app-youtube/template.html
// module id = 897
// module chunks = 0